import { ref, watch } from '@vue/composition-api';
import { trackEvent } from './../../../utils/index';

export function useHashtagBehaviorTracer(keyword, searchResult) {
  const _searchResultTraceInfo = ref();

  function resetSearchResultTracer() {
    _searchResultTraceInfo.value = {
      hasSent: false,
      searchKeyword: keyword.value,
      isValid: false,
      exposedItemIdsSet: new Set(),
      exposureTime: Date.now(),
    };
  }

  resetSearchResultTracer();

  function searchResultTracer() {
    // eslint-disable-next-line prefer-const
    let { hasSent, isValid, searchKeyword, exposureTime, exposedItemIdsSet } = _searchResultTraceInfo.value;

    if (searchKeyword && !hasSent) {
      if (!isValid) {
        const exposureDuration = Date.now() - exposureTime;
        if (exposureDuration > 3000) {
          isValid = true;
        }
      }

      if (exposedItemIdsSet.size) {
        trackEvent('targeting_hashtag_search_result_expose', {
          is_valid: isValid ? '1' : '0',
          exposed_result_count: exposedItemIdsSet.size,
          search_keyword: searchKeyword,
        });
      }

      _searchResultTraceInfo.value.hasSent = true;
    }
  }

  function onScrollResultList() {
    _searchResultTraceInfo.value.isValid = true;
  }

  function onShowSearchResultList() {
    _searchResultTraceInfo.value.exposureTime = Date.now();
  }

  function onHideSearchResultList() {
    searchResultTracer();
  }

  function afterClickResultListItem(index) {
    trackEvent('targeting_hashtag_search_result_click', { result_index: index + 1 });
    _searchResultTraceInfo.value.isValid = true;
  }

  function onHoverResultListItem() {
    _searchResultTraceInfo.value.isValid = true;
  }

  function onExposeResultListItem(node) {
    const id = node?.data?.id;
    if (id) {
      _searchResultTraceInfo.value.exposedItemIdsSet.add(id);
    }
  }

  function onSelectTreeInteraction(eventName) {
    if (eventName === 'clickKeywordInput') {
      trackEvent('targeting_hashtag_search_input_click');
    } else if (eventName === 'clearFilterKeyword') {
      trackEvent('targeting_hashtag_search_input_click_clear');
    } else if (eventName === 'scrollTreeOptions') {
      onScrollResultList();
    }
  }

  watch(searchResult, () => {
    searchResultTracer();
    resetSearchResultTracer();
  });

  return {
    onShowSearchResultList,
    onHideSearchResultList,
    afterClickResultListItem,
    onHoverResultListItem,
    onExposeResultListItem,
    onSelectTreeInteraction,
  };
}
